import { parseCSV } from "../io/csv"
import config from "../config"
import tableUtils from "./tableUtils.js"
import logger from "../logger"

function readTable(data) {
  let table = data.format == 'csv' ? parseCSV(data.text, ",") : parseCSV(data.text, '\t')
  let delimiters = [',', '\t']
  let delimiterId = 0
  while(table.columnNames.length <= 1) {
    table = parseCSV(data.text, delimiters[delimiterId])
    delimiterId++
  }
  console.log("TABLE", table)
  table.fileName = data.fileName
  return table
}

function parseAllNumbers(table) {
  for(let row of table.rows) {
    for(let i = 0; i < row.length; i++) {
      let cell = row[i]
      if(cell.match(/^(([0-9]+[ \u00A0])*(([0-9]+[,.][0-9]+)|([0-9]+)))$/)) {
        row[i] = +(cell.replace(/[^0-9,\.-]/g,'').replace(',','.'))
      }
    }
  }
  return table
}

function checkField(fields, rf) {
  //console.log("CHECK FIELD", fields, rf)
  if(rf instanceof Array) {
    for(let part of rf) {
      if(part instanceof Array) {
        if(checkFields(fields, part)) return true;
      } else {
        if(fields.indexOf(part) != -1) return true;
      }
    }
    console.log("field", rf, "not found")
    return false;
  } else {
    let found = fields.indexOf(rf) != -1
    if(!found) console.log("field", rf, "not found")
    return found
  }
}

function checkFields(fields, required) {
  //console.log("CHECK FIELDS", fields, required)
  for(let rf of required) {
    if(!checkField(fields, rf)) return false
  }
  return true
}

function checkType(table, type, language) {
  let columnNames = table.columnNames
  console.log("input fields", columnNames)
  console.log("LANG", JSON.stringify(language.columnTranslation))
  const columnTranslations = Object.keys(language.columnTranslation)
  let translatedColumnNames = columnNames.map((name) => {
    const columnName = columnTranslations.find(c => {
      const cNorm = c.trim()
        .replace(/\u00A0/gi, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/ +/gi, ' ')
      const nameNorm = name.trim()
        .replace(/\u00A0/gi, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/ +/gi, ' ')
      return cNorm == nameNorm
    })
    if(!columnName) return null
    return language.columnTranslation[columnName]
  })
  console.log('type',type.name, language.lang)
  console.log("translated fields", translatedColumnNames.filter(x=>!!x))
  console.log("required fields", JSON.stringify(type.requiredFields))
/*  console.log('fields not found', type.requiredFields.filter(
    f => translatedColumnNames.map(x=>JSON.stringify(x)).indexOf(JSON.stringify(f)) != -1
  ))*/
  return checkFields(translatedColumnNames, type.requiredFields)
}

function detectFileType(table, inputConfig) {
  for(let typeName in inputConfig) {
    let typeConfig = inputConfig[typeName]
    for(let language of typeConfig.languages) {
      //console.log("check type ",typeName, language.lang)
      if(checkType(table, typeConfig, language)) {
        return [typeName, language.lang]
      }
    }
  }
  return null
}

function removeUndefinedColumns(table) {
  let inputColumnsCount = table.columnNames.length
  let inputColumnNames = table.columnNames
  let undefinedColumnsCount = 0
  for(let i = 0; i < inputColumnsCount; i++) if(!table.columnNames[i]) undefinedColumnsCount ++
  let definedColumnsCount = inputColumnsCount - undefinedColumnsCount
  let rowsCount = table.rows.length
  for(let i = 0; i < rowsCount; i++) {
    let inRow = table.rows[i]
    let outRow = new Array(definedColumnsCount)
    let outp = 0
    for(let inp = 0; inp < inputColumnsCount; inp ++) {
      if(inputColumnNames[inp]) outRow[outp++] = inRow[inp]
    }
    table.rows[i] = outRow
  }
  table.columnNames = table.columnNames.filter(col => !!col)
  return table
}

function translateTable(table, [dataType, lang], inputConfig) {
  let tconf = inputConfig[dataType]
  let translation = tconf.languages.filter((l) => l.lang == lang)[0].columnTranslation
  const columnTranslations = Object.keys(translation)
  console.log("RAW TABLE COLUMN NAMES", table.columnNames)
  table.columnNames = table.columnNames.map((name) => {
    const columnName = columnTranslations.find(c => {
      const cNorm = c.trim()
        .replace(/\u00A0/gi, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/ +/gi, ' ')
      const nameNorm = name.trim()
        .replace(/\u00A0/gi, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/ +/gi, ' ')
      if(cNorm == nameNorm) console.log("COMP", cNorm, nameNorm)
      return cNorm == nameNorm
    })
    if(!columnName) return null
    return translation[columnName]
  })
  console.log("TRANSLATED TABLE COLUMN NAMES", table.columnNames)
  return removeUndefinedColumns(table)
}

function parseNumericColumns(table, columns) {
  const columnIdsByName = tableUtils.columnIdsByName(table)
  const columnIds = columns.map(col => columnIdsByName.get(col)).filter(x=> !!x)
  for(let row of table.rows) {
    for(let i = 0; i < columnIds.length; i++) {
      let cell = row[columnIds[i]]
      let simpleValue = cell.match(/^[^0-9]*(([0-9]+[\s\u00A0])*(([0-9]+[,.][0-9]+)|([0-9]+)))[^0-9]*$/)
      if(simpleValue) {
        row[columnIds[i]] = +(simpleValue[1].replace(/[^0-9,\.-]/g,'').replace(',','.'))
      } else {
        console.error("BAD NUMERIC CELL", cell)
        throw new Error("unknownTableType")
      }
    }
  }
  return table
}

function removeSummary(table, [dataType, lang], inputConfig) {
  let tconf = inputConfig[dataType]
  let summaryRegex = tconf.languages.filter((l) => l.lang == lang)[0].summaryRegex
  let rowId
  for(rowId = table.rows.length-1; rowId >=0; rowId--) {
    let row = table.rows[rowId]
    let found = false
    for(let regex of summaryRegex) {
      if(row[0].match(regex)) found = true;
    }
    if(!found) break;
  }
  console.log("ROWS BEFORE", table.rows.length, "SLICE",rowId)
  console.log("REMOVE", table.rows.length - rowId - 1, "LAST ROWS OF SUMMARY")
  table.rows = table.rows.slice(0, (rowId + 1))
  console.log("ROWS AFTER", table.rows.length)
  return table
}

function parseData(data, inputConfig) {
  let table = readTable(data)

  let fileType = detectFileType(table, inputConfig)
  if(!fileType) throw new Error("unknownTableType")


  let [dataType, language] = fileType
  console.error("DETECTED FILE TYPE", dataType, language)
  table = removeSummary(table, fileType, inputConfig)
  table = translateTable(table, fileType, inputConfig)
  table.type = dataType
  //console.log("TRANSLATED TABLE", table)
  table = parseNumericColumns(table, inputConfig[dataType].numericFields)
  return table
}

const methods = {
  parseData
}

export default methods;

if(typeof window == "undefined" || window.document === undefined) { // Web Worker Code
  logger.install()
  logger.addWorkerParentLogDestination()
  onmessage = (msg) => {
    let { method, serializedArgs, requestId } = msg.data
    let args = serializedArgs
    //console.log("WORKER CALL", method, args)
    let result = methods[method].apply(null, args)
    //console.log("WORKER RES", result)
    postMessage({
      type: "response",
      result,
      requestId
    })
  }
  postMessage({
    type: "ready"
  })
}



// WEBPACK FOOTER //
// ./src/logic/csvParser.js